import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { HashRouter as Router } from 'react-router-dom';
import LoginContext from '../../providers/authLoginProvider';
import LoginRoutes from './loginRoutes';

function Login({ onLogin, errorMsg }) {
  const ctxValue = useMemo(() => ({
    onLogin, errorMsg,
  }), [onLogin, errorMsg]);
  return (
    <LoginContext.Provider value={ctxValue}>
      <Router>
        <LoginRoutes />
      </Router>
    </LoginContext.Provider>
  );
}

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
};

Login.defaultProps = {
  errorMsg: null,
};

export default Login;
